import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import AppShell from './components/AppShell';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DailyReport from './pages/DailyReport';
import ReportsHistory from './pages/ReportsHistory';
import PbaMaturation from './pages/PbaMaturation';
import PbaDelivery from './pages/PbaDelivery';
import BonsLivraison from './pages/BonsLivraison';
import BonLivraison from './pages/BonLivraison';
import BLPrint from './pages/BLPrint';
import VerifierBL from './pages/VerifierBL';
import Factures from './pages/Factures';
import FactureForm from './pages/FactureForm';
import Facture from './pages/Facture';
import FacturePrint from './pages/FacturePrint';
import Proformas from './pages/Proformas';
import Proforma from './pages/Proforma';
import RapportPrint from './pages/RapportPrint';
import RapportHebdo from './pages/RapportHebdo';
import Journal from './pages/Journal';
import Amortissements from './pages/amortissements/Amortissements';
import Planification from './pages/planning/Planification';
import Immobilisation from './pages/amortissements/Immobilisation';
import Clients from './pages/Clients';
import Parametres from './pages/Parametres';
import Stock from './pages/Stock';
import StockIntrants from './pages/StockIntrants';
import StockArmatures from './pages/StockArmatures';
import Qualite from './pages/qualite/Qualite';
import QualiteSysteme from './pages/qualite/QualiteSysteme';
import CoutRevient from './pages/CoutRevient';
import Direction from './pages/Direction';
import Garde from './pages/garde/Garde';
import JournalGarde from './pages/garde/Journal';
import Systeme from './pages/Systeme';
import RhPointage from './pages/rh/RhPointage';
import RhPresence from './pages/rh/RhPresence';
import RhAbsences from './pages/rh/RhAbsences';
import RhConges from './pages/rh/RhConges';
import RhEmployes from './pages/rh/RhEmployes';
import RhParametres from './pages/rh/RhParametres';
import ComptaSituation from './pages/compta/ComptaSituation';
import Creances from './pages/compta/Creances';
import FacturesFournisseurs from './pages/compta/FacturesFournisseurs';
import Paie from './pages/compta/Paie';
import BulletinPrint from './pages/compta/BulletinPrint';
import Poteaux from './pages/Poteaux';
import Salaires from './pages/compta/Salaires';
import BonsCommande from './pages/achats/BonsCommande';
import BonCommande from './pages/achats/BonCommande';
import BonCommandeForm from './pages/achats/BonCommandeForm';
import BCPrint from './pages/achats/BCPrint';
import BCClientPrint from './pages/marches/BCClientPrint';
import Fournisseurs from './pages/achats/Fournisseurs';
import DemandesAchat from './pages/achats/DemandesAchat';
import DemandeAchat from './pages/achats/DemandeAchat';
import DemandeAchatForm from './pages/achats/DemandeAchatForm';
import Depenses from './pages/achats/Depenses';
import SuiviCaisse from './pages/caisse/SuiviCaisse';
import UserManagement from './pages/UserManagement';
import Messages from './pages/Messages';
import RapportBriquesForm from './pages/briques/RapportBriquesForm';
import RapportsBriques from './pages/briques/RapportsBriques';
import RapportBriques from './pages/briques/RapportBriques';
import ArticlesBriques from './pages/briques/ArticlesBriques';
import Pannes from './pages/pannes/Pannes';
import Panne from './pages/pannes/Panne';
import PanneForm from './pages/pannes/PanneForm';
import PannesCouts from './pages/pannes/PannesCouts';
import Marches from './pages/marches/Marches';
import Marche from './pages/marches/Marche';
import MarcheForm from './pages/marches/MarcheForm';
import Adl from './pages/marches/Adl';
import MonthlyInventory from './pages/MonthlyInventory';
import PhysicalInventory from './pages/PhysicalInventory';
import InventoryHistory from './pages/InventoryHistory';
import ChangePassword from './pages/ChangePassword';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/verifier" element={<VerifierBL />} />
            <Route path="/verifier/:numero" element={<VerifierBL />} />
            <Route path="/bons-livraison/:id/imprimer" element={<ProtectedRoute allow={['comptable']}><BLPrint /></ProtectedRoute>} />
            <Route path="/factures/:id/imprimer" element={<ProtectedRoute domain="compta" validator><FacturePrint /></ProtectedRoute>} />
            <Route path="/rapports/:id/imprimer" element={<ProtectedRoute everyone><RapportPrint /></ProtectedRoute>} />
            <Route path="/proformas/:id/imprimer" element={<ProtectedRoute domain="compta" validator><FacturePrint kind="proforma" /></ProtectedRoute>} />
            <Route path="/compta/paie/bulletins/:id/imprimer" element={<ProtectedRoute domain="compta" paie><BulletinPrint /></ProtectedRoute>} />
            <Route path="/compta/paie/mois/:periode/imprimer" element={<ProtectedRoute domain="compta" paie><BulletinPrint /></ProtectedRoute>} />
            <Route path="/achats/commandes/:id/imprimer" element={<ProtectedRoute domain="achats" allow={['comptable']}><BCPrint /></ProtectedRoute>} />
            <Route path="/marches/:id/bc" element={<ProtectedRoute everyone><BCClientPrint /></ProtectedRoute>} />
            <Route element={<AppShell />}>
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute dashboardAccess>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/daily-report"
              element={
                <ProtectedRoute>
                  <DailyReport />
                </ProtectedRoute>
              }
            />
            <Route path="/poteaux" element={<ProtectedRoute numerotation><Poteaux /></ProtectedRoute>} />
            <Route path="/rapports/:id/modifier" element={<ProtectedRoute dashboardAccess><DailyReport /></ProtectedRoute>} />
            <Route
              path="/reports-history"
              element={
                <ProtectedRoute dashboardAccess>
                  <ReportsHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pba-maturation"
              element={
                <ProtectedRoute dashboardAccess>
                  <PbaMaturation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pba-delivery"
              element={
                <ProtectedRoute>
                  <PbaDelivery />
                </ProtectedRoute>
              }
            />
            <Route path="/rh" element={<ProtectedRoute domain="rh"><RhPointage /></ProtectedRoute>} />
            <Route path="/rh/presence" element={<ProtectedRoute domain="rh"><RhPresence /></ProtectedRoute>} />
            <Route path="/rh/absences" element={<ProtectedRoute domain="rh"><RhAbsences /></ProtectedRoute>} />
            <Route path="/rh/conges" element={<ProtectedRoute domain="rh"><RhConges /></ProtectedRoute>} />
            <Route path="/rh/employes" element={<ProtectedRoute domain="rh"><RhEmployes /></ProtectedRoute>} />
            <Route path="/rh/parametres" element={<ProtectedRoute domain="rh"><RhParametres /></ProtectedRoute>} />
            <Route path="/compta" element={<ProtectedRoute domain="compta"><ComptaSituation /></ProtectedRoute>} />
            <Route path="/compta/creances" element={<ProtectedRoute domain="compta"><Creances /></ProtectedRoute>} />
            <Route path="/compta/factures-fournisseurs" element={<ProtectedRoute domain="compta"><FacturesFournisseurs /></ProtectedRoute>} />
            <Route path="/compta/paie" element={<ProtectedRoute domain="compta" paie><Paie /></ProtectedRoute>} />
            <Route path="/compta/salaires" element={<ProtectedRoute domain="compta" paie><Salaires /></ProtectedRoute>} />
            <Route path="/rapport-hebdo" element={<ProtectedRoute everyone><RapportHebdo /></ProtectedRoute>} />
            <Route path="/planification" element={<ProtectedRoute everyone><Planification /></ProtectedRoute>} />
            <Route path="/planification/:onglet" element={<ProtectedRoute everyone><Planification /></ProtectedRoute>} />
            <Route path="/planification/:onglet/:id" element={<ProtectedRoute everyone><Planification /></ProtectedRoute>} />
            <Route path="/amortissements" element={<ProtectedRoute everyone><Amortissements /></ProtectedRoute>} />
            <Route path="/amortissements/:id" element={<ProtectedRoute everyone><Immobilisation /></ProtectedRoute>} />
            <Route path="/marches" element={<ProtectedRoute everyone><Marches /></ProtectedRoute>} />
            <Route path="/marches/nouveau" element={<ProtectedRoute everyone><MarcheForm /></ProtectedRoute>} />
            <Route path="/marches/adl/:id" element={<ProtectedRoute everyone><Adl /></ProtectedRoute>} />
            <Route path="/marches/:id" element={<ProtectedRoute everyone><Marche /></ProtectedRoute>} />
            <Route path="/marches/:id/modifier" element={<ProtectedRoute everyone><MarcheForm /></ProtectedRoute>} />
            <Route path="/pannes" element={<ProtectedRoute everyone><Pannes /></ProtectedRoute>} />
            <Route path="/pannes/nouvelle" element={<ProtectedRoute dashboardAccess><PanneForm /></ProtectedRoute>} />
            <Route path="/pannes/couts" element={<ProtectedRoute everyone><PannesCouts /></ProtectedRoute>} />
            <Route path="/pannes/:id" element={<ProtectedRoute everyone><Panne /></ProtectedRoute>} />
            <Route path="/pannes/:id/modifier" element={<ProtectedRoute dashboardAccess><PanneForm /></ProtectedRoute>} />
            <Route path="/briques/rapport" element={<ProtectedRoute domain="briques"><RapportBriquesForm /></ProtectedRoute>} />
            <Route path="/briques/rapports" element={<ProtectedRoute domain="briques"><RapportsBriques /></ProtectedRoute>} />
            <Route path="/briques/rapports/:id" element={<ProtectedRoute everyone><RapportBriques /></ProtectedRoute>} />
            <Route path="/briques/rapports/:id/modifier" element={<ProtectedRoute domain="briques"><RapportBriquesForm /></ProtectedRoute>} />
            <Route path="/briques/articles" element={<ProtectedRoute domain="briques"><ArticlesBriques /></ProtectedRoute>} />
            <Route path="/messages" element={<ProtectedRoute everyone><Messages /></ProtectedRoute>} />
            <Route path="/messages/:id" element={<ProtectedRoute everyone><Messages /></ProtectedRoute>} />
            <Route path="/demandes-achat" element={<ProtectedRoute everyone><DemandesAchat /></ProtectedRoute>} />
            <Route path="/demandes-achat/nouvelle" element={<ProtectedRoute everyone><DemandeAchatForm /></ProtectedRoute>} />
            <Route path="/demandes-achat/:id" element={<ProtectedRoute everyone><DemandeAchat /></ProtectedRoute>} />
            <Route path="/demandes-achat/:id/modifier" element={<ProtectedRoute everyone><DemandeAchatForm /></ProtectedRoute>} />
            <Route path="/depenses" element={<ProtectedRoute depenses><Depenses /></ProtectedRoute>} />
            <Route path="/caisse" element={<ProtectedRoute depenses><SuiviCaisse /></ProtectedRoute>} />
            <Route path="/achats" element={<ProtectedRoute domain="achats" allow={['comptable']}><BonsCommande /></ProtectedRoute>} />
            <Route path="/achats/commandes/nouveau" element={<ProtectedRoute domain="achats"><BonCommandeForm /></ProtectedRoute>} />
            <Route path="/achats/commandes/:id" element={<ProtectedRoute domain="achats" allow={['comptable']}><BonCommande /></ProtectedRoute>} />
            <Route path="/achats/commandes/:id/modifier" element={<ProtectedRoute domain="achats"><BonCommandeForm /></ProtectedRoute>} />
            <Route path="/achats/fournisseurs" element={<ProtectedRoute domain="achats" allow={['comptable']}><Fournisseurs /></ProtectedRoute>} />
            <Route path="/systeme" element={<ProtectedRoute adminOnly><Systeme /></ProtectedRoute>} />
            <Route path="/direction" element={<ProtectedRoute everyone><Direction /></ProtectedRoute>} />
            <Route path="/garde" element={<ProtectedRoute domain="garde"><Garde /></ProtectedRoute>} />
            <Route path="/garde/journal" element={<ProtectedRoute domain="garde"><JournalGarde /></ProtectedRoute>} />
            <Route path="/cout-revient" element={<ProtectedRoute everyone><CoutRevient /></ProtectedRoute>} />
            <Route path="/qualite" element={<ProtectedRoute><Qualite /></ProtectedRoute>} />
            <Route path="/qualite/:onglet" element={<ProtectedRoute><Qualite /></ProtectedRoute>} />
            <Route path="/qualite-systeme" element={<ProtectedRoute><QualiteSysteme /></ProtectedRoute>} />
            <Route path="/qualite-systeme/:onglet" element={<ProtectedRoute><QualiteSysteme /></ProtectedRoute>} />
            <Route path="/stock-armatures" element={<ProtectedRoute><StockArmatures /></ProtectedRoute>} />
            <Route path="/stock-intrants" element={<ProtectedRoute allow={['achats']}><StockIntrants /></ProtectedRoute>} />
            <Route path="/deliveries-history" element={<Navigate to="/bons-livraison" replace />} />
            <Route path="/bons-livraison" element={<ProtectedRoute allow={['comptable']}><BonsLivraison /></ProtectedRoute>} />
            <Route path="/bons-livraison/:id" element={<ProtectedRoute allow={['comptable']}><BonLivraison /></ProtectedRoute>} />
            <Route path="/factures" element={<ProtectedRoute domain="compta" validator><Factures /></ProtectedRoute>} />
            <Route path="/factures/nouvelle" element={<ProtectedRoute domain="compta"><FactureForm /></ProtectedRoute>} />
            <Route path="/factures/:id" element={<ProtectedRoute domain="compta" validator><Facture /></ProtectedRoute>} />
            <Route path="/factures/:id/modifier" element={<ProtectedRoute domain="compta"><FactureForm /></ProtectedRoute>} />
            <Route path="/proformas" element={<ProtectedRoute domain="compta" validator><Proformas /></ProtectedRoute>} />
            <Route path="/proformas/nouvelle" element={<ProtectedRoute domain="compta"><FactureForm kind="proforma" key="pf-new" /></ProtectedRoute>} />
            <Route path="/proformas/:id" element={<ProtectedRoute domain="compta" validator><Proforma /></ProtectedRoute>} />
            <Route path="/proformas/:id/modifier" element={<ProtectedRoute domain="compta"><FactureForm kind="proforma" key="pf-edit" /></ProtectedRoute>} />
            <Route path="/clients" element={<ProtectedRoute domain="compta"><Clients /></ProtectedRoute>} />
            <Route path="/parametres" element={<ProtectedRoute adminOnly><Parametres /></ProtectedRoute>} />
            <Route path="/journal" element={<ProtectedRoute adminOnly><Journal /></ProtectedRoute>} />
            <Route
              path="/stock"
              element={
                <ProtectedRoute>
                  <Stock />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute adminOnly>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/monthly-inventory"
              element={
                <ProtectedRoute dashboardAccess>
                  <MonthlyInventory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/physical-inventory"
              element={
                <ProtectedRoute dashboardAccess>
                  <PhysicalInventory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inventory-history"
              element={
                <ProtectedRoute dashboardAccess>
                  <InventoryHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/change-password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            </Route>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;